import React from "react";
import { MessageSquare, FolderOpen } from "lucide-react";
import { useFeatureFlag, FLAGS } from "../config/featureFlags";
import "./SidebarModeToggle.css";

/**
 * SidebarModeToggle - Switch between Chats and Files modes
 *
 * Positioned next to Settings button at bottom of sidebar.
 * Only visible when c3_workspace feature flag is enabled.
 */
const SidebarModeToggle = ({ mode, onModeChange }) => {
  const c3Enabled = useFeatureFlag(FLAGS.C3_WORKSPACE);

  // Don't render if C3 workspace is not enabled
  if (!c3Enabled) {
    return null;
  }

  // Check if upload is in progress before switching away from files
  const handleModeChange = (newMode) => {
    if (mode === "files" && newMode === "chats" && window.__fileBrowserUploading) {
      const confirmed = window.confirm(
        "Upload in progress! Switching to chats will cancel it. Continue?"
      );
      if (!confirmed) return;
    }
    onModeChange(newMode);
  };

  return (
    <div className="sidebar-mode-toggle">
      <button
        className={`mode-btn ${mode === "chats" ? "active" : ""}`}
        onClick={() => handleModeChange("chats")}
        title="Chats"
        aria-label="Show chats"
      >
        <MessageSquare size={16} />
      </button>
      <button
        className={`mode-btn ${mode === "files" ? "active" : ""}`}
        onClick={() => handleModeChange("files")}
        title="Files"
        aria-label="Show files"
      >
        <FolderOpen size={16} />
      </button>
    </div>
  );
};

export default SidebarModeToggle;
